import { render } from "./Alcada.vue?vue&type=template&id=71879196"
import script from "./Alcada.vue?vue&type=script&lang=js"
export * from "./Alcada.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__